import { Component, OnInit, OnChanges, Input } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService, AlertService } from '@app/_services';
import { ReviewService } from '../../review.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { first } from 'rxjs/operators';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { PropertyService } from '@app/_components/property/property.service';
import * as moment from 'moment';
import { ConstantService } from '@app/_services/constant.service';
import { Reservation, ReservationService } from '@app/_components/reservation';
import { ActivityService } from '@app/_components/activity';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { GuestExitSurveyComponent } from '@app/_components/guest-exit-survey/guest-exit-surveyest/guest-exit-survey.component';
import { GuestExitSurveyService } from '@app/_components/guest-exit-survey/guest-exit-survey.service';

@Component({
    selector: 'app-review',
    templateUrl: './review.component.html',
    styleUrls: ['./review.component.css'],
    standalone: false
})
export class ReviewComponent implements OnInit, OnChanges {

	form1: UntypedFormGroup;
	formLoading = false;
	formErrorMessage: string;
	properties: any;
	showReservationSearch = false;

	review: any;

	validationMessages =
		{
			reviewId: [{ type: 'required', message: 'Required' }],
			createDate: [{ type: 'required', message: 'Required' }],
			lastUpdate: [{ type: 'required', message: 'Required' }],
			checkInDate: [{ type: 'required', message: 'Required' }],
			reviewDate: [{ type: 'required', message: 'Required' }],
			rating: [{ type: 'required', message: 'Required' }],
			ratingScale: [{ type: 'required', message: 'Required' }],

			// 1 approved / 2 suspended / 3 incomplete
			status: [{ type: 'required', message: 'Required' }],
			title: [{ type: 'required', message: 'Required' }],
			reviewDesc: [{ type: 'required', message: 'Required' }, { type: 'minlength', message: 'Minimum length is 50 characters' }],
			responseDesc: [{ type: 'required', message: 'Required' }],
			helpfulCount: [{ type: 'required', message: 'Required' }],
			notHelpfulCount: [{ type: 'required', message: 'Required' }],

			// reviewer
			firstName: [{ type: 'required', message: 'Required' }],
			lastName: [{ type: 'required', message: 'Required' }],
			emailAddress: [{ type: 'required', message: 'Required' }],
			screenName: [{ type: 'required', message: 'Required' }],
			city: [{ type: 'required', message: 'Required' }],
			state: [{ type: 'required', message: 'Required' }],
			country: [{ type: 'required', message: 'Required' }],

			// links
			propertyCode: [{ type: 'required', message: 'Required' }],
			shortTermRentalId: [{ type: 'required', message: 'Required' }],
			reservationId: [{ type: 'required', message: 'Required' }],
			activityId: [{ type: 'required', message: 'Required' }],
			guestFollowupRequest:[],
			yelpReviewRequest:[],
      notes:[],
		};



	statuses = [
		{ name: 'Draft', value: 1 },
		{ name: 'New', value: 2 },
		{ name: 'Approved', value: 3 },
		{ name: 'Rejected', value: 4 },
	];
    activities: any;
    countries: any;
    states: any[];
    reservationId: any;
    reservation: any;
	guestExitSurvey: any;



	/*
	*
	*
	*/
	constructor(
		private reservationService: ReservationService,
		private activityService: ActivityService,
		private formBuilder: UntypedFormBuilder,
		private reviewService: ReviewService,
		private guestExitSurveyService: GuestExitSurveyService,
		private messageService: MessageService,
		private dynamicDialogRef: DynamicDialogRef,
		private dynamicDialogConfig: DynamicDialogConfig,
		private propertyService: PropertyService,
		public dialogService: DialogService,
		private dialog: MatDialog,
		private constants: ConstantService,
		private confirmationService: ConfirmationService
	) {
		this.countries = this.constants.countries;
		this.states = this.constants.states;
		}

	ngOnInit(): void {
		this.loadProperties();
		this.loadActivities();
		this.buildForm();
		if (this.dynamicDialogConfig.data) {

			this.reservationId = this.dynamicDialogConfig.data.reservationId;
			console.log("this.reservationId this.reservationId : "+this.reservationId);
			if(this.reservationId){
				this.fetchReservationById(this.reservationId);
			}
			// get the review
			this.review = this.dynamicDialogConfig.data.review;
			if(this.review?.guestExitSurveyId != null){
				this.findguestExitSurveyById(this.review?.guestExitSurveyId);
			}

			// create dates for primeng
			this.fixDates();

			// patch to form
			this.form1.patchValue(this.dynamicDialogConfig.data.review);
		}
	}

	fetchReservationById(reservationId: any) {
			try {
				this.reservationService.findById(reservationId)
					.subscribe(
						res => {
							console.log('findById reservationaaaaaaaa : ' + JSON.stringify(res));
							this.reservation = res.data.reservation;
							this.form1.patchValue({
								shortTermRentalId: this.reservation.shortTermRental.shortTermRentalId,
								propertyCode: this.reservation.shortTermRental.propertyCode,
								checkInDate:  moment(this.reservation.checkInDate).toDate(),
								firstName: this.reservation.guestProfile.firstName,
								lastName: this.reservation.guestProfile.lastName,
								emailAddress: this.reservation.guestProfile.emailAddress,
								city: this.reservation.guestProfile.adrCity,
								state: this.reservation.guestProfile.adrState,
								country: this.reservation.guestProfile.adrCountry,
							});
							return this.reservation;
						},
						err => {
							console.log('Feature-Update FAIL: ' + JSON.stringify(err));
						},
						() => { });
			} catch (error) {
				console.log('Form Invalid: ' + JSON.stringify(error));
			}
		}

	setReservation(reservation: any) {
		console.log('changes!' + JSON.stringify(reservation));
		this.form1.get('firstName').setValue(reservation.guestFirstName);
		this.form1.get('lastName').setValue(reservation.guestLastName);
		this.form1.get('city').setValue(reservation.guestCity);
		this.form1.get('state').setValue(reservation.guestState);
		this.form1.get('country').setValue(reservation.guestCountry);
		this.form1.get('checkInDate').setValue(moment(reservation.checkInDate).toDate());
		this.form1.get('shortTermRentalId').patchValue(Number(reservation.shortTermRentalId));
		this.form1.get('reservationId').setValue(reservation.reservationId);
	}

	onFindReservationClick() {
		this.showReservationSearch = !this.showReservationSearch;
	}

	onAddClick() {
		this.addReview();
	}

	onUpdateClick() {
		this.updateReview();
	}

	onDeleteClick() {
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete this review?',
			accept: () => {
				this.review.action = 'DELETED'; // to tell caller what we did
				this.deleteReview();
				this.dynamicDialogRef.close(this.review);
			}
		});
	}

	ngOnChanges() {

	}

	onCloseClick() {
		// pass the review back to the review-list component to update the list.
		this.dynamicDialogRef.close(this.review);
	}

	findReviewById(reviewId: number) {
		this.formLoading = true;
		this.reviewService.findById(reviewId).pipe(first()).subscribe(
			res => {
				this.review = res.data.review;

				// create dates for primeng
				this.fixDates();

				this.form1.patchValue(this.review);
			},
			err => {
				console.log('error In findReviewById is: ' + JSON.stringify(err));
				this.formLoading = false;
				this.messageService.add({ severity: 'error', summary: 'Error', detail: 'We were unable to retrieve your review: ' + err.message, sticky: true });
			},
			() => { this.formLoading = false; });
	}



	addReview() {
		this.customValidate();
		this.form1.markAllAsTouched();

		// stop here if form is invalid
		if (this.form1.invalid) {
			return;
		}

		this.formLoading = true;
		this.reviewService.add(this.form1.value)
			.pipe(first()).subscribe(
				res => {
					this.review = res.data.review;

					// create dates for primeng
					this.fixDates();
					this.form1.patchValue(this.review);
					this.review.action = 'ADDED'; // to tell caller what we did
					this.messageService.add({ severity: 'success', summary: 'Success!', detail: 'New review added.', sticky: false });
				},
				err => {
					// Do NOT reset formLoading on error — a 504 means the review may have been created.
					// Keep button disabled to prevent a duplicate review from being submitted.
					console.log('error in reviewService.add: ' + JSON.stringify(err));
					this.formErrorMessage = err.message;
					this.messageService.add({ severity: 'error', summary: 'Create Failed', detail: 'Review save may have completed. Please refresh before retrying.', sticky: true });
				},
				() => { this.formLoading = false; });
	}

	updateReview() {
		this.customValidate();
		this.form1.markAllAsTouched();

		// stop here if form is invalid
		if (this.form1.invalid) {
			return;
		}

		this.formLoading = true;
		this.reviewService.update(this.form1.value)
			.pipe(first()).subscribe(
				res => {
					this.review = res.data.review;
					// create dates for primeng
					this.fixDates();
					this.form1.patchValue(this.review);
					this.review.action = 'UPDATED'; // to tell caller what we did
					this.messageService.add({ severity: 'success', summary: 'Update Successfull', detail: 'Settings updated.', sticky: false });

				},
				err => {
					// Do NOT reset formLoading on error — a 504 means the update may have persisted.
					// Keep button disabled to block re-submit.
					console.log('error in reviewService.update: ' + JSON.stringify(err));
					this.formErrorMessage = err.message;
					this.messageService.add({ severity: 'error', summary: 'Update Failed', detail: 'Review update may have completed. Please refresh before retrying.', sticky: true });
				},
				() => { this.formLoading = false; });
	}


	deleteReview() {
		this.customValidate();
		this.formLoading = true;
		this.reviewService.delete(this.review.reviewId)
			.pipe(first()).subscribe(
				res => {

				},
				err => {
					console.log('error in reviewService.add: ' + JSON.stringify(err));
					this.formLoading = false;
					this.formErrorMessage = err.message;
					this.messageService.add({ severity: 'error', summary: 'Create Failed', detail: 'We were unable to add the review: ' + err.message, sticky: true });
				},
				() => { this.formLoading = false; });
	}

	buildForm() {
		this.form1 = this.formBuilder.group({
			reviewId: [''],
			createDate: [''],
			lastUpdate: [''],
			checkInDate: ['', Validators.required],
			reviewDate: ['', Validators.required],
			rating: ['', Validators.required],
			ratingScale: [''],

			// 1 approved / 2 suspended / 3 incomplete
			status: [1, Validators.required],
			title: [''],
			reviewDesc: [''], //, Validators.compose([Validators.minLength(50), Validators.required])
			responseDesc: [''],
			helpfulCount: [''],
			notHelpfulCount: [''],

			// reviewer
			firstName: ['', Validators.required],
			lastName: ['', Validators.required],
			emailAddress: [''],
			screenName: [''],
			city: [''],
			state: [''],
			country: [''],

			// links
			shortTermRentalId: ['', Validators.required],
			reservationId: [''],
			activityId: [''],
			guestFollowupRequest: [],
			yelpReviewRequest: [],
      notes: [],
		});
	}

	loadProperties() {
		if (!this.properties || this.properties === undefined || this.properties.length < 1) {
			this.propertyService.propertySummaryForShortData()
				.subscribe(
					res => {
						// console.log('findAllPropertiesSummary: ' + JSON.stringify(res));
						this.properties = res.data.properties;
						return this.properties;
					},
					err => {
						console.log('Feature-Update FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: 'Create Failed', detail: 'We were unable to add the review: ' + err.message, sticky: true });
					},
					() => { });
		}
	}

	loadActivities() {
		if (!this.activities || this.activities === undefined || this.activities.length < 1) {
			this.activityService.findAll()
				.subscribe(
					res => {
						console.log('findAllactivities: ' + JSON.stringify(res));
						this.activities = res.data.activitys;
						return this.activities;
					},
					err => {
						console.log('Feature-Update FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: 'Create Failed', detail: 'We were unable to add the review: ' + err.message, sticky: true });
					},
					() => { });
		}
	}

	fixDates() {
		// create date objects - why can't primeng do this?
		this.review.checkInDate = moment(this.review.checkInDate).toDate();
		this.review.reviewDate = moment(this.review.reviewDate).toDate();
	}

	customValidate() {
		// if NEW or APPROVED
		if (this.form1.get('status').value === 2 || this.form1.get('status').value === 3) {
			// this.form1.get('reviewDesc').setValidators([Validators.minLength(50), Validators.required]);
			// this.form1.get('reviewDesc').updateValueAndValidity();
			// this.form1.get('title').setValidators([Validators.required]);
			// this.form1.get('title').updateValueAndValidity();
		}
		else {
			// this.form1.get('reviewDesc').clearValidators();
			// this.form1.get('title').clearValidators();
		}
	}

	findguestExitSurveyById(guestExitSurveyId: number) {
		this.formLoading = true;
		this.guestExitSurveyService.findById(guestExitSurveyId).pipe(first()).subscribe(
			res => {
				this.guestExitSurvey = res.data.guestExitSurvey;
			},
			err => {
				console.log('error In findReviewById is: ' + JSON.stringify(err));
				this.formLoading = false;
				this.messageService.add({ severity: 'error', summary: 'Error', detail: 'We were unable to retrieve your review: ' + err.message, sticky: true });
			},
			() => { this.formLoading = false; });
	}

	/*********
		* Edit Button
		*
		*/
		openGuestExitSurveyDialog() {
			if (this.review.guestExitSurveyId != null) {
				const dialogConfig = new MatDialogConfig();
			this.onCloseClick();

			// settings
			dialogConfig.disableClose = false;
			dialogConfig.autoFocus = true;
			dialogConfig.hasBackdrop = true;
			dialogConfig.maxWidth = "60vw";
				dialogConfig.width = "40vw";

			// pass data, ie rateBuicket: this.shortTermRentalId,
			dialogConfig.data = {
				guestExitSurvey: this.guestExitSurvey,
				title: 'Edit Guest Exit Survey'
			};

			// open the popup and get a reference to it called dialogRef
			const dialogRef = this.dialog.open(GuestExitSurveyComponent, dialogConfig);
			} else {
				this.messageService.add({ severity: 'info', summary: 'Not Exist', detail: 'This review is not exist into guest exit survey.', life: 3000 });
			}
		}

		findReservationById(reservationId: any) {
			this.formLoading = true;
			this.reservationService.findById(reservationId)
				.pipe(first())
				.subscribe(
					res => {
						console.log('findReservationById: ' + JSON.stringify(res));
						this.reservation = res.data.reservation;
						var url = "/order/"+this.reservation?.order?.orderId;
						window.open(url, '_blank');
					},
					err => {
						console.log('error In findReservationById is: ' + JSON.stringify(err));
						this.formLoading = false;
						this.messageService.add({ severity: 'error', summary: 'Error', detail: 'We were unable to retrieve your reservation: ' + err.message, sticky: true });
					},
					() => { this.formLoading = false; });
		}

}
